export default "__VITE_ASSET__ChkjmCpo__"